import { IAlertNotification, SignalRConnectionInfo, useNewNotificationListener } from '@cscglobal-tbs/notifications-ui';
import { useGetEnterprise } from '../api/enterprise/enterprise';

//TODO: After moving the notification hooks from home to common, we should be able to remove this hook
//and just utilize useNewNotificationListener directly
export const useNewNotificationListenerHelper = (
    signalrConnectionInfo: SignalRConnectionInfo | undefined,
    notifications: IAlertNotification[] | undefined
) => {
    const { data: enterpriseData } = useGetEnterprise();
    const enterpriseId = enterpriseData?.enterpriseId;

    const validateNewNotification: ((newNotification: IAlertNotification) => Promise<boolean>) | undefined = async (
        newNotification: IAlertNotification
    ) => {
        return newNotification.data?.enterpriseId === enterpriseId;
    };

    return useNewNotificationListener(signalrConnectionInfo, notifications, enterpriseId, validateNewNotification);
};
